exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".userLabel {\n    font-weight: bold;\n}", "", {"version":3,"sources":["/home/dev/bitool-new/client/app/main/user/user-list.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;CACrB","file":"user-list.css","sourcesContent":[".userLabel {\n    font-weight: bold;\n}"],"sourceRoot":""}]);

// exports
